import { ChangeDetectionStrategy, Component, ViewChild, OnInit, ChangeDetectorRef } from "@angular/core";
import { CashplusOptOutFacade } from "./cashplus-optout.facade";
import { Observable, take, tap } from "rxjs";
import { OptOutTermsSlider } from "@modules/cashplus/features/opt-out/opt-out-terms-slider";
import {
	DYNAMIC_TERMS_TOKEN,
	TermsAndConditionsUpdatesComponent
} from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.component";
import { AgreementBundle, UserJourney } from "@modules/shared/terms-and-conditions/entities/terms-and-conditions.model";
import { TermsAndConditionsService } from "@modules/shared/terms-and-conditions/services/terms-and-conditions.service";
import { UserService } from "@main-services/user.service";

@Component({
	selector: "cashplus-optout",
	templateUrl: "./cashplus-optout.component.html",
	styleUrls: ["./cashplus-optout.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CashplusOptOutFacade],
	standalone: false
})
export class CashPlusOptOutComponent implements OnInit {
	@ViewChild(DYNAMIC_TERMS_TOKEN) dynamic_terms: TermsAndConditionsUpdatesComponent;
	public isApiLoading$: Observable<boolean> = this.optOutFacade.isOptOutInProgress$();
	public optOutTermsSlider: OptOutTermsSlider = new OptOutTermsSlider();

	public bundles: AgreementBundle[] = [];
	public dynamictermAndConditionActive = false;

	public isDynamictermAndConditionActive$ = this.termsAndConditionsService.isDynamictermAndConditionActive$.pipe(
		tap((isActive) => {
			this.dynamictermAndConditionActive = isActive;
		})
	);

	constructor(
		private optOutFacade: CashplusOptOutFacade,
		private readonly termsAndConditionsService: TermsAndConditionsService,
		private readonly cdr: ChangeDetectorRef,
		private readonly userService: UserService
	) {}

	public get dynamicTermsInvalid(): boolean {
		return this.dynamictermAndConditionActive && !!this.dynamic_terms?.termsAndConditionsForm?.invalid;
	}

	public get isButtonDisabled(): boolean {
		const staticTermsInvalid = !this.dynamictermAndConditionActive && !this.optOutTermsSlider.sell_terms;
		return this.dynamicTermsInvalid || staticTermsInvalid;
	}

	ngOnInit(): void {
		this.termsAndConditionsService
			.getAgreementBundleData$([UserJourney.CashPlusOptOut])
			.pipe(take(1))
			.subscribe((bundles) => {
				this.bundles = bundles;
				this.cdr.markForCheck();
			});
	}

	public onButtonClick(): void {
		if (this.dynamictermAndConditionActive) {
			if (this.bundles.length > 0 && this.dynamicTermsInvalid) {
				this.dynamic_terms.wiggleIt();
				return;
			}
			if (this.bundles.length === 0) {
				this.optOutFacade.onOptOutRequest();
				return;
			}
			this.termsAndConditionsService.acceptTerms(
				[UserJourney.CashPlusOptOut],
				this.dynamic_terms?.termsAndConditionsForm?.value,
				() => {
					this.optOutFacade.onOptOutRequest();
				}
			);
		} else {
			this.optOutTermsSlider.sell_terms
				? this.optOutFacade.onOptOutRequest()
				: this.optOutTermsSlider.wiggleSell();
		}
	}
}
